export default __webpack_public_path__ + "static/media/Logo_no_Background.c2dcba38.png";